import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../../../store';
import axios from '../../../axios';

type PaggingConfiguration = {
  take: number;
  skip: number;
  getTotal: boolean;
};

type PaggingResult = {
  totalNumber?: number;
  elements: AnnotationStandard[];
};

export type AnnotationStandard = {
  id: string;
  name: string;
  version: string;
  description: string;
  released: string;
  releaseDate: Date;
  deprecated: boolean;
  deprecationDate: Date;
  standardBody: string;
  canEdit: boolean;
  findingTypes: [];
};

export const take = 7;

const annotationStandardsSlice = createSlice({
  name: 'annotationStandards',
  initialState: {
    annotationStandards: Array<AnnotationStandard>(),
    isLoading: false,
    currentPage: 0,
    size: take,
    totalNumberOfTurbines: 0
  },
  reducers: {
    fetchAnnotationStandardsStarted(state) {
      state.isLoading = true;
    },
    fetchAnnotationStandardsSuccess(
      state,
      action: PayloadAction<{ standards: Array<AnnotationStandard>; totalNumber?: number; currentPage: number }>
    ) {
      const { standards, totalNumber, currentPage } = action.payload;
      state.annotationStandards = standards;
      state.currentPage = currentPage;
      if (totalNumber) {
        state.totalNumberOfTurbines = totalNumber;
      }
      state.isLoading = false;
    },
    fetchAnnotationStandardsFailed(state) {
      state.isLoading = false;
    },
    setSize: (state, action: PayloadAction<number>) => {
      state.size = action.payload;
    }
  }
});

export const {
  fetchAnnotationStandardsStarted,
  fetchAnnotationStandardsSuccess,
  fetchAnnotationStandardsFailed,
  setSize
} = annotationStandardsSlice.actions;

export const fetchAnnotationStandards = (init: boolean, take: number, newPage: number): AppThunk => async (dispatch, getState) => {
  dispatch(fetchAnnotationStandardsStarted());

  const { size } = getState().annotationStandards;

  if (take !== size) {
    dispatch(setSize(take));
  }

  const config: PaggingConfiguration = {
    take: take,
    skip: (newPage - 1) * take,
    getTotal: init
  };

  try {
    const response = await axios.post<PaggingResult>(`/annotationstandards/get-standards`, config);

    if (response && response.data) {
      const { elements, totalNumber } = response.data;

      dispatch(fetchAnnotationStandardsSuccess({ currentPage: newPage, standards: elements, totalNumber: totalNumber }));
    }
  } catch {
    dispatch(fetchAnnotationStandardsFailed());
  }
};

export default annotationStandardsSlice.reducer;
